namespace GeniuzPOS.Lookups {
    export namespace LookupCategoryService {
        export const baseUrl = 'Lookups/LookupCategory';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LookupCategoryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Lookups/LookupCategory/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>LookupCategoryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
